<template>
  <footer>
    <!-- <div id="newsletter">
      <div class="container align-self-center">
        <div class="row">
          <div class="col-12 col-md-6">
            <h3 id="ftr-heading">Subscribe to Our Newsletter</h3>
          </div>
          <div class="col-12 col-md-6 align-self-center" id="ftr-contr-1">
            <input id="email-sub" type="email" name="Email" placeholder="Enter your email address">
            <a href="#" class="email-btn"><i class="fas fa-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </div> -->
    <section class="footer-main">
      <div class="container">
        <div class="row mx-0">
          <div class="col-12 col-sm-6 col-md-4 col-xl">
            <h3 class="title">Help</h3>
            <ul class="list-view">
              <li><a target="_blank" href="https://www.mntc.org/get-help/">Get Help</a></li>
              <li><a target="_blank" href="https://www.mntc.org/womens-treatment/">Women’s Treatment</a></li>
              <li><a target="_blank" href="https://www.mntc.org/mens-treatment/">Men’s Treatment</a></li>
              <li><a target="_blank" href="https://www.mntc.org/teen-treatment/">Teen Treatment</a></li>
              <li><a target="_blank" href="https://www.mntc.org/ongoing-recovery/">Ongoing Recovery</a></li>
            </ul>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl">
            <h3 class="title">Support</h3>
            <ul class="list-view">
              <li><a target="_blank" href="https://www.mntc.org/ways-to-give/">Ways to Give</a></li>
              <li><a target="_blank" href="https://www.mntc.org/events/">Events</a></li>
              <li><a target="_blank" href="https://www.mntc.org/church-partners/">Church Partners</a></li>
              <li><a target="_blank" href="https://www.mntc.org/volunteer/">Volunteer</a></li>
              <li><a target="_blank" href="https://www.mntc.org/mentors/">Mentor</a></li>
            </ul>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl">
            <h3 class="title">Locations</h3>
            <ul class="list-view">
              <li><a target="_blank" href="https://www.mntc.org/minneapolis/">Minneapolis</a></li>
              <li><a target="_blank" href="https://www.mntc.org/rochester-mens-center/">Rochester – Men’s</a></li>
              <li><a target="_blank" href="https://www.mntc.org/rochester-womens-center/">Rochester – Women’s</a></li>
              <li><a target="_blank" href="https://www.mntc.org/duluth/">Duluth</a></li>
              <li><a target="_blank" href="https://www.mntc.org/brainerd/">Brainerd</a></li>
            </ul>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl">
            <h3 class="title">Webinars</h3>
            <ul class="list-view">
              <li><a target="_blank" href="https://www.mntc.org/education-and-training/">Education</a></li>
            </ul>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl">
            <h3 class="title">Careers</h3>
            <ul class="list-view">
              <li><a target="_blank" href="https://www.mntc.org/internships/">Internships</a></li>
              <li><a target="_blank" href="https://www.mntc.org/career-opportunities/">Career Opportunities</a></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="copyright">
      <div class="container">
        <div class="row mx-0">
          <div class="col-12 col-md-6 mb-4 mb-md-0 align-self-center text-center text-md-start">
            <span>
              <a id="cpy-r">© {{ new Date().getFullYear() }} Minnesota Adult & Teen Challenge. All Rights Reserved.</a>
            </span>
          </div>
          <div class="col-12 col-md-6 align-self-center text-center text-md-end">
            <a target="_blank" href="https://www.mntc.org/privacy-policy/" class="supports">Privacy Policy</a>
            <a target="_blank" href="https://www.mntc.org/termsofuse/" class="supports">Terms of Use</a>
            <a target="_blank" href="https://www.mntc.org/cares/" class="supports">Cares</a>
            <a target="_blank" href="https://www.healthpartners.com/hp/legal-notices/disclosures/transparency/index.html" class="supports">Transparency in Coverage</a>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped></style>